import React from "react";
import { Link } from "react-router-dom";
import {
  getObjectKeyByValue,
  formatNumberStringForExcel
} from "../../../lib/utils";
import {
  Departments,
  ApplicationStatuses,
  CurrencyTypes,
  RecipientTypes
} from "../../../lib/systemVariables";
import { toastr } from "react-redux-toastr";

import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import ConfirmationModal from "../../commonComponents/shared/ConfirmationModal";
import ExportButton from "../../commonComponents/shared/ExportButton";
import PrintModal from "../../printingComponents/PrintModal";

export default class ApplicationsPageActionsView extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        printApplicationsModal: false,
        approveSelectedModal: false,
        sendACHModal: false
      }
    };
  }

  componentDidMount() {
    // Calculate initial counts
    if (this.props.actions.updateSelectedCounts && this.props.selected.length > 0) {
      this.props.actions.updateSelectedCounts(this.props.selected, this.props.userProfile, this.props.funds);
    }
  }

  componentDidUpdate(prevProps) {
    // Update counts when selected applications change
    if (prevProps.selected !== this.props.selected && this.props.actions.updateSelectedCounts) {
      this.props.actions.updateSelectedCounts(this.props.selected, this.props.userProfile, this.props.funds);
    }
  }

  async getWireApplicationForExport(applicationIds) {
    let applications = await this.props.actions.wireApplications(
      applicationIds
    );
    if (applications.data.length) {
      applications.data = applications.data.map(d => ({
        ...d,
        teudatZahut: formatNumberStringForExcel(d.teudatZahut)
      }));
    }
    return applications;
  }

  getSelectionAction() {
    const isUSUser =
      this.props.userProfile.departments &&
      this.props.userProfile.departments.indexOf(Departments.US) >= 0;
    const isIsraelUser =
      this.props.userProfile.departments &&
      this.props.userProfile.departments.indexOf(Departments.IL) >= 0;

    const checkCount = this.props.selectedCounts ? this.props.selectedCounts.check : 0;
    const achCount = this.props.selectedCounts ? this.props.selectedCounts.ach : 0;
    const wireCount = this.props.selectedCounts ? this.props.selectedCounts.wire : 0;

    let action;
    if (this.props.filters.status === ApplicationStatuses.New) {
      action = (
        <button
          className="btn btn-flat btn-small approve"
          disabled={this.props.approving.loading}
          onClick={this.toggleModal.bind(this, "approveSelectedModal")}
        >
          <i className="icon ion-ios-checkmark approved-text icon-left large-text middle" />
          {this.props.approving.loading
            ? "Approving Selected..."
            : "Approve Selected"}
        </button>
      );
    } else if (this.props.filters.status === ApplicationStatuses.Approved) {
      action = (
        <div className="approved-btns" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'flex-start', justifyContent: 'flex-start' }}>
          {isUSUser &&
            checkCount > 0 && (
              <button
                className="btn btn-flat btn-small selection-action-btn selection-action-btn--with-badge"
                disabled={this.props.printing.loading}
                onClick={this.toggleModal.bind(this, "printApplicationsModal")}
              >
                <span className="selection-action-btn__content">
                  <i className="material-icons selection-action-btn__icon selection-action-btn__icon--print" aria-hidden="true">print</i>
                  <span className="selection-action-btn__label">Print</span>
                </span>
                <span className="selection-action-btn__badge">{checkCount}</span>
              </button>
            )}
          {isUSUser &&
            achCount > 0 && (
              <button
                className="btn btn-flat btn-small selection-action-btn selection-action-btn--with-badge"
                disabled={this.props.sendingACH.loading}
                onClick={this.toggleModal.bind(this, "sendACHModal")}
                title="ACH is enabled for organizations that have bank account info. Fund must be ACH-enabled and third-party payments are not allowed."
              >
                <span className="selection-action-btn__content">
                  <i className="material-icons selection-action-btn__icon middle" aria-hidden="true">swap_horiz</i>
                  <span className="selection-action-btn__label">Send ACH</span>
                </span>
                <span className="selection-action-btn__badge">{achCount}</span>
              </button>
            )}
          {isIsraelUser &&
            wireCount > 0 && (
              <ExportButton
                text="Wire"
                count={wireCount}
                buttonClassName="selection-action-btn selection-action-btn--with-badge"
                disabled={this.props.noData}
                exportHeaders={[
                  { label: "First Name", value: "firstName", default: "" },
                  { label: "Last Name", value: "lastName", default: "" },
                  { label: "Teudat", value: "teudatZahut", default: "" },
                  { label: "Wire Info", value: "wireInfo", default: "" },
                  { label: "Address", value: "address", default: "" },
                  { label: "City", value: "city", default: "" },
                  { label: "Amount", value: "amount", default: "" },
                  { label: "Pay To", value: "payTo", default: "" },
                  {
                    label: "Currency Symbol",
                    value: "currencySymbol",
                    default: ""
                  }
                ]}
                fileName="Approved-wires"
                getDataForExport={this.getWireApplicationForExport.bind(
                  this,
                  this.props.selected
                    .filter(app => app.currency === CurrencyTypes.Shekel)
                    .map(app => app.applicationId),
                  true
                )}
                onGetDataSuccess={this.props.actions.onActionCompleted.bind(
                  this,
                  this.props.selected.filter(
                    app => app.currency !== CurrencyTypes.Shekel
                  )
                )}
              />
            )}
        </div>
      );
    }

    return (
      action && (
        <div className="flex-center">
          {action}
        </div>
      )
    );
  }

  async approveApplications() {
    await this.props.actions.approveApplications(
      this.props.selected.map(app => ({
        applicationId: app.applicationId,
        amount: app.amount,
        currency: getObjectKeyByValue(CurrencyTypes, app.currency)
      }))
    );
    if (this.props.approving.success) {
      toastr.success(
        `${this.props.selected.length} ${
          this.props.selected.length > 1
            ? "Applications have"
            : "Application has"
        } been approved.`
      );
      this.props.actions.onActionCompleted();
    }
  }

  async printApplications(printerId) {
    await this.props.actions.printChecks("applications", printerId, {
      applicationIds: this.props.selected
        .filter(app => app.currency === CurrencyTypes.Dollar)
        .map(app => app.applicationId)
    });
    if (this.props.printing.success) {
      this.props.actions.onActionCompleted(
        this.props.selected.filter(app => app.currency !== CurrencyTypes.Dollar)
      );
    }
  }

  getQualifyingAchApplications() {
    return this.props.selected.filter(
        app => app.currency === CurrencyTypes.Dollar && 
        app.recipient && 
        app.recipient.hasAchAccount && 
        app.recipient.applicantType === RecipientTypes.Organization &&
        app.payTo === "Recipient" &&
        app.fundAllowsACH === true
    );
  }

  async sendACHToSelected() {
    const selectedAchApplications = this.getQualifyingAchApplications();

    if (selectedAchApplications.length === 0) {
        toastr.warning(
            "No ACH Applications",
            "None of the selected applications qualify for ACH transfer."
        );
        return;
    }
    
    const applicationIds = selectedAchApplications.map(app => app.applicationId);
    
    try {
      const response = await this.props.actions.sendACHApplications(applicationIds);

      if (!response.success) {
        throw new Error(response.message || "ACH transfer failed");
      }

        const achResults = selectedAchApplications.map(app => {
        const apiResult = response.data ? 
          response.data.find(result => result.transactionId === app.applicationId) : 
                null;
            
            return {
                applicationId: app.applicationId,
                orgName: app.recipient.lastOrOrgName,
                amount: app.amount,
                success: apiResult ? apiResult.isSuccess : false,
                errorMessage: apiResult ? apiResult.message : 'No response received from server'
            };
        });

        // Pass results to parent component
        if (this.props.onACHResultsReady) {
            this.props.onACHResultsReady(achResults);
        }
        return true;
    } catch (error) {
        toastr.error(
            "ACH Transfer Failed",
            error.message || "ACH transfer could not be initiated. Please try again."
        );
        return false;
    }
  }

  toggleModal(modalName) {
    this.setState({
      showModals: {
        ...this.state.showModals,
        [modalName]: !this.state.showModals[modalName]
      }
    });
  }

  render() {
    return (
      <div className="flex-one">
        <div className="btn-group-top flex-right subheader-btns">
          <div className="action-buttons">
            {this.props.selected.length > 0 && this.getSelectionAction()}
             {this.props.canCreate && (
              <Link className="btn btn-primary btn-small action-btn" to="/applications/create-application">
                <i className="material-icons icon-left action-btn-icon">add</i>
                Create
              </Link>
            )}
          </div>
        </div>

        {this.state.showModals.printApplicationsModal && (
          <PrintModal
            close={this.toggleModal.bind(this, "printApplicationsModal")}
            onPrintSuccess={this.pushRoute.bind(this, "/print")}
            count={this.props.selected.length}
            print={this.printApplications.bind(this)}
          />
        )}

        <ConfirmationModal
          show={this.state.showModals.approveSelectedModal}
          title="Approve Applications"
          message={`Are you sure you want to approve ${this.props.selected.length} selected application${this.props.selected.length !== 1 ? "s" : ""}?`}
          close={this.toggleModal.bind(this, "approveSelectedModal")}
          confirm={this.approveApplications.bind(this)}
          loading={this.props.approving.loading}
          success={this.props.approving.success}
          errorMessage={this.props.approving.message || "This action could not be completed. Please try again."}
        />

        <ConfirmationModal
          show={this.state.showModals.sendACHModal}
          title="Send ACH"
          message={`Are you sure you want to send ACH to the ${this.getQualifyingAchApplications().length} selected recipient${this.getQualifyingAchApplications().length !== 1 ? "s" : ""}?`}
          close={this.toggleModal.bind(this, "sendACHModal")}
          confirm={this.sendACHToSelected.bind(this)}
          loading={this.props.sendingACH.loading}
          success={this.props.sendingACH.success}
          errorMessage={this.props.sendingACH.message || "ACH transfer could not be initiated. Please try again."}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applications/ApplicationsPageActionsView.jsx